export enum FooterLinks {
  TERMS_OF_USE = 'TERMS_OF_USE',
  NOTICE_DISCLOSURE = 'NOTICE_DISCLOSURE',
  ABOUT_UNITED_HEALTH_CARE = 'ABOUT_UNITED_HEALTH_CARE',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  PROVIDER_DATA_INFORMATION = 'PROVIDER_DATA_INFORMATION',
  LEGAL_ENTITIES = 'LEGAL_ENTITIES',
  STATE_SPECIFIC_EMPLOYER_INDIVIDUAL_EXCHANGE_PLAN_INFORMATION = 'STATE_SPECIFIC_EMPLOYER_INDIVIDUAL_EXCHANGE_PLAN_INFORMATION',
  ACCESSIBILITY_STATEMENT = 'ACCESSIBILITY_STATEMENT',
  LANGUAGE_ASSISTANCE_NON_DISCRIMINATION_NOTICE = 'LANGUAGE_ASSISTANCE_NON_DISCRIMINATION_NOTICE',
  GEHA_CONTINUITY_OF_CARE = 'GEHA_CONTINUITY_OF_CARE',
  GEHA_PRIVACY_POLICY = 'GEHA_PRIVACY_POLICY',
  GEHA_TERMS_OF_USE = 'GEHA_TERMS_OF_USE',
  GEHA_EDITORIAL_POLICY = 'GEHA_EDITORIAL_POLICY',
  GEHA_ACCESSIBILITY = 'GEHA_ACCESSIBILITY',
  GEHA_SURPRISE_BILLING = 'GEHA_SURPRISE_BILLING',
  GEHA_CONTACT_US = 'GEHA_CONTACT_US',
  GEHA_INFORMATION_ON_PAYMENT_OF_OUT_OF_NETWORK_BENEFITS = 'GEHA_INFORMATION_ON_PAYMENT_OF_OUT_OF_NETWORK_BENEFITS',
  GEHA_HEALTHCARE_FRAUD = 'GEHA_HEALTHCARE_FRAUD',
  IMPORTANT_INFORMATION = 'IMPORTANT_INFORMATION',
  ACCESSIBILITY = 'ACCESSIBILITY',
}
